import script from "./CrowdfundingAnimationHeart.vue?vue&type=script&setup=true&lang=js"
export * from "./CrowdfundingAnimationHeart.vue?vue&type=script&setup=true&lang=js"

import "./CrowdfundingAnimationHeart.vue?vue&type=style&index=0&id=23fb09de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fb09de"]])

export default __exports__